import React, { useState, useEffect } from "react"
import PropTypes from "prop-types"
import { useSelector } from "react-redux"
import { Link } from "react-router-dom"
import { Dropdown, DropdownToggle, DropdownMenu, Row, Col } from "reactstrap"
import SimpleBar from "simplebar-react"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faBell, faCakeCandles } from "@fortawesome/free-solid-svg-icons"
//i18n
import { withTranslation } from "react-i18next"

const NotificationDropdown = props => {
  const {
    notification,
    notificationCount,
    birthNotification,
    AnniversaryNotification,
    Followups,
  } = useSelector(state => state.NotificationReducer)

  // Declare a new state variable, which we'll call "menu"
  const [menu, setMenu] = useState(false)
  return (
    <React.Fragment>
      <Dropdown
        isOpen={menu}
        toggle={() => setMenu(!menu)}
        className="dropdown d-inline-block"
        tag="li"
      >
        <DropdownToggle
          className="btn header-item noti-icon position-relative"
          tag="button"
          id="page-header-notifications-dropdown"
        >
          <i className="bx bx-bell bx-tada" />
          <span className="badge bg-danger rounded-pill">
            {/* {notificationCount
              ? notificationCount.birthdays + notificationCount.others || 0
              : null} */}
            {localStorage.getItem("notificationCount")}
          </span>
        </DropdownToggle>

        <DropdownMenu className="dropdown-menu dropdown-menu-lg dropdown-menu-end p-0">
          <div className="p-3">
            <Row className="align-items-center">
              <Col>
                <h6 className="m-0"> {props.t("Notifications")} </h6>
              </Col>
              {/* <div className="col-auto">
                <Link to="#" className="small">
                  {" "}
                  View All
                </Link>
              </div> */}
            </Row>
          </div>

          <SimpleBar style={{ height: "230px" }}>
            {birthNotification &&
            birthNotification !== undefined &&
            birthNotification !== null &&
            birthNotification.length > 0
              ? birthNotification.map((item, index) => (
                  <div key={index}>
                    {item.type === "birthday_User" ||
                    item.type === "birthday_Employee" ? (
                      <Link
                        to="/notifications"
                        className="text-reset notification-item"
                        onClick={()=>setMenu(false)}
                      >
                        <div className="d-flex">
                          <>
                            <div className="avatar-xs me-2">
                              <span className="avatar-title bg-primary rounded-circle font-size-16">
                                <FontAwesomeIcon icon={faCakeCandles} />
                              </span>
                            </div>
                            <div className="flex-grow-1">
                              <h6 className="mt-0">
                                {props.t(
                                  `${
                                    item.data
                                      ? item.data.first_name +
                                        " " +
                                        item.data.last_name
                                      : ""
                                  }`
                                )}
                              </h6>
                              <div className="font-size-12 text-muted">
                                <p className="mb-1">
                                  {props.t(`${item.message}`)}
                                </p>
                                {/* <p className="mb-0">
                              <i className="mdi mdi-clock-outline" />{" "}
                              {props.t("3 min ago")}{" "}
                            </p> */}
                              </div>
                            </div>
                          </>
                        </div>
                      </Link>
                    ) : null}
                  </div>
                ))
              : null}

            {notificationCount && notificationCount.birthdays > 0 ? (
              <Link
                to="/notifications"
                className="text-reset notification-item"
                onClick={()=>setMenu(false)}
              >
                <div className="d-flex">
                  <>
                    <div className="avatar-xs me-2">
                      <span className="avatar-title bg-primary rounded-circle font-size-16">
                        <FontAwesomeIcon icon={faCakeCandles} />
                      </span>
                    </div>
                    <div className="flex-grow-1">
                      <h6 className="mt-0">
                        {props.t(
                          `Total ${notificationCount.birthdays} Birthdays`
                        )}
                      </h6>
                      <div className="font-size-12 text-muted">
                        <p className="mb-1">
                          {props.t(
                            `Today's Birthday Count: ${
                              notificationCount.birthdays || 0
                            }`
                          )}
                        </p>
                      </div>
                    </div>
                  </>
                </div>
              </Link>
            ) : null}

            {AnniversaryNotification && AnniversaryNotification.length > 0 ? (
              <Link
                to="/notifications"
                className="text-reset notification-item"
                onClick={()=>setMenu(false)}
              >
                <div className="d-flex">
                  <>
                    <div className="avatar-xs me-2">
                      <span className="avatar-title bg-primary rounded-circle font-size-16">
                        <FontAwesomeIcon icon={faCakeCandles} />
                      </span>
                    </div>
                    <div className="flex-grow-1">
                      <h6 className="mt-0">
                        {props.t(
                          (AnniversaryNotification &&
                            AnniversaryNotification.length) ||
                            0 + " " + "Anniversary"
                        )}
                      </h6>
                      <div className="font-size-12 text-muted">
                        <p className="mb-1">
                          {props.t(
                            `Today's Anniversary Count: ${
                              (AnniversaryNotification &&
                                AnniversaryNotification.length) ||
                              0
                            }`
                          )}
                        </p>
                      </div>
                    </div>
                  </>
                </div>
              </Link>
            ) : null}
            {notification && notification.length > 0 ? (
              <Link
                to="/notifications"
                className="text-reset notification-item"
                onClick={()=>setMenu(false)}
              >
                <div className="d-flex">
                  <>
                    <div className="avatar-xs me-2">
                      <span className="avatar-title bg-primary rounded-circle font-size-16 text-white">
                        <FontAwesomeIcon icon={faBell} />
                      </span>
                    </div>
                    <div className="flex-grow-1">
                      <h6 className="mt-0">
                        {props.t(
                          `${
                            notification && notification.length
                          } Policy Expired`
                        )}
                      </h6>
                      <div className="font-size-12 text-muted">
                        <p className="mb-1">
                          {props.t(
                            `Today's Policy Count: ${
                              (notification && notification.length) || 0
                            }`
                          )}
                        </p>
                      </div>
                    </div>
                  </>
                </div>
              </Link>
            ) : null}

            {Followups && Followups.length > 0 ? (
              <Link
                to="/notifications"
                className="text-reset notification-item"
                onClick={()=>setMenu(false)}
              >
                <div className="d-flex">
                  <>
                    <div className="avatar-xs me-2">
                      <span className="avatar-title bg-primary rounded-circle font-size-16">
                        <FontAwesomeIcon icon={faBell} />
                      </span>
                    </div>
                    <div className="flex-grow-1">
                      <h6 className="mt-0">
                        {props.t(`${Followups && Followups.length} Followups`)}
                      </h6>
                      <div className="font-size-12 text-muted">
                        <p className="mb-1">
                          {props.t(
                            `Today's Followups Count: ${
                              (Followups && Followups.length) || 0
                            }`
                          )}
                        </p>
                      </div>
                    </div>
                  </>
                </div>
              </Link>
            ) : null}
          </SimpleBar>
          <div className="p-2 border-top d-grid">
            <Link
              className="btn btn-sm btn-link font-size-14 text-center"
              to="/notifications"
              onClick={()=>setMenu(false)}
            >
              <i className="mdi mdi-arrow-right-circle me-1"></i>{" "}
              <span key="t-view-more">
                {props.t(
                  `View ${
                    notificationCount && notificationCount.others
                      ? notificationCount.others + notificationCount.birthdays
                      : 0
                  } Notifications..`
                )}
              </span>
            </Link>
          </div>
        </DropdownMenu>
      </Dropdown>
    </React.Fragment>
  )
}

export default withTranslation()(NotificationDropdown)

NotificationDropdown.propTypes = {
  t: PropTypes.any,
}
